import React, { useEffect, useState } from "react";

const Facts = () => {
  return (
    <>
      <section className="facts-section">
        <div className="auto-container">
          <div className="inner-container">
            <div className="fact-counter">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <h1 style={{ color: "white", textAlign: "center" }}>
                        <a
                          href="../assets/files/projects-2022-24.pdf"
                          target="_blank"
                          title="Tap to view projects details"
                          style={{ color: "white", textAlign: "center" }}
                        >
                          &#9758; Support Summary (2017-2026){" "}
                        </a>
                      </h1>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix">
                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="0ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="3000"
                          style={{ color: "white" }}
                          data-stop="300"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">
                        Monthly Groceries for Widows & Seniors
                      </div>
                      <a
                        href="/free-grocery-for-widows-and-senior-citizen"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="300ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box alternate">
                        <span
                          className="count-text"
                          data-speed="3000"
                          style={{ color: "white" }}
                          data-stop="125"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">Small Businesses Established</div>
                      <a
                        href="/apna-rozgar"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="600ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="100"
                        >
                          0
                        </span>
                        +
                      </div>
                      <div className="counter-title">
                        Patients Receiving Medical Aid Annually (~10 Monthly)
                      </div>
                      <a
                        href="/medical-support"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="900ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="156"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">
                        Clean Water Projects (148 Hand Pumps, 8 Solar Pumps)
                      </div>
                      <a
                        href="/water-hand-pumps"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>
                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="900ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="40"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">Educational Scholarships Provided</div>
                      <a
                        href="/basic-schools"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>

                <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="900ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="2"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">
                        Women's Vocational Training Centers (115 Students Enrolled)
                      </div>
                      <a
                        href="/womens-vocational-training"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>

                 <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="900ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="45"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">
                        Heatstroke Relief Camps
                      </div>
                      <a
                        href="/heatstroke-relief-camps"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>

                 <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
                  <div
                    className="inner wow fadeInLeft"
                    data-wow-delay="900ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="content">
                      <div className="count-outer count-box">
                        <span
                          className="count-text"
                          data-speed="2000"
                          style={{ color: "white" }}
                          data-stop="42"
                        >
                          0
                        </span>
                      </div>
                      <div className="counter-title">
                        Orphan Marriage Assistance
                      </div>
                      <a
                        href="/orphan-marriage-assistance"
                        target="_blank"
                        style={{ color: "#2ea4ff" }}
                        className="counter-title"
                      >
                        Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Facts;
